<template>
    <header :class="headerClasses">
        <div class="container mx-auto flex justify-between items-center">
            <router-link to="/home" class="flex items-center gap-3 min-w-0">
                <img
                    src="/header-logo-mobile.png"
                    alt="Logo Qui est le plus riche ?"
                    class="h-24 w-24 md:hidden shrink-0 object-contain"
                >
                <img
                    src="/header-logo-icon.png"
                    alt="Logo Qui est le plus riche ?"
                    class="hidden md:block h-16 w-16 lg:h-20 lg:w-20 shrink-0 object-contain"
                >
                <div class="hidden md:block text-xl lg:text-2xl font-bold leading-tight whitespace-nowrap">
                    Qui est le plus riche ?
                </div>
            </router-link>

            <router-link to="/calculateur-richesse">
                <button class="btn-gold mr-6 hidden md:inline-block">Calculateur de richesse</button>
            </router-link>

            <nav class="hidden md:flex items-center space-x-6">
                <a href="#" class="hover:text-gold">Classements</a>
                <!--<a href="#" class="hover:text-gold">Portraits</a>-->
                <a href="#" class="hover:text-gold">Astuces</a>

                <template v-if="isAuthenticated">
                    <router-link :to="{ name: 'BuyRanking' }">
                        <button class="btn-gold">Monter au classement</button>
                    </router-link>

                    <div class="relative" @click="dropdownOpen = !dropdownOpen">
                        <button class="hover:text-gold flex items-center gap-1">
                            Mon Compte
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        <div v-if="dropdownOpen"
                            class="absolute right-0 mt-2 w-56 bg-backgroundLight rounded shadow-glow-gold py-2 z-[10001]">
                            <router-link :to="{ name: 'BuyRanking' }"
                                class="block px-4 py-2 hover:bg-gold hover:text-primary">Acheter des
                                points</router-link>
                            <router-link :to="{ name: 'UserAccount' }"
                                class="block px-4 py-2 hover:bg-gold hover:text-primary">Mon Compte</router-link>
                            <router-link :to="{ name: 'UserRanking' }"
                                class="block px-4 py-2 hover:bg-gold hover:text-primary">Mon Classement</router-link>

                            <button @click="logout"
                                class="w-full text-left px-4 py-2 text-red-400 hover:bg-gold hover:text-primary transition">
                                Déconnexion
                            </button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <router-link :to="{ name: 'LoginRegister', query: { view: 'login' } }"
                        class="hover:text-gold">Connexion</router-link>
                    <router-link :to="{ name: 'LoginRegister', query: { view: 'register' } }">
                        <button class="btn-primary">Inscription</button>
                    </router-link>
                </template>
            </nav>

            <button @click="isOpen = !isOpen" class="md:hidden focus:outline-none" aria-label="Toggle menu">
                <svg v-if="!isOpen" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <Transition enter-active-class="animate-slideDown" leave-active-class="animate-slideUp">
            <nav v-show="isOpen" class="md:hidden mt-2 px-4 space-y-2 bg-backgroundLight rounded z-[10001]">
                <a href="#" class="block p-2 hover:bg-gold hover:text-primary rounded">Classements</a>
                <!--<a href="#" class="block p-2 hover:bg-gold hover:text-primary rounded">Portraits</a>-->
                <a href="#" class="block p-2 hover:bg-gold hover:text-primary rounded">Astuces</a>

                <template v-if="isAuthenticated">
                    <router-link :to="{ name: 'BuyRanking' }"
                        class="block p-2 hover:bg-gold hover:text-primary rounded">Acheter des points</router-link>
                    <router-link :to="{ name: 'UserAccount' }"
                        class="block p-2 hover:bg-gold hover:text-primary rounded">Mon Compte</router-link>
                    <router-link :to="{ name: 'UserRanking' }"
                        class="block p-2 hover:bg-gold hover:text-primary rounded">Mon Classement</router-link>
                    <button @click="logout"
                        class="w-full text-left p-2 text-red-400 hover:bg-gold hover:text-primary rounded transition">
                        Déconnexion
                    </button>
                </template>
                <template v-else>
                    <router-link :to="{ name: 'LoginRegister', query: { view: 'login' } }"
                        class="block p-2 hover:bg-gold hover:text-primary rounded">Connexion</router-link>
                    <router-link :to="{ name: 'LoginRegister', query: { view: 'register' } }" class="block p-2 rounded">
                        <button class="btn-primary w-full">Inscription</button>
                    </router-link>
                </template>
            </nav>
        </Transition>
    </header>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const isOpen = ref(false)
const dropdownOpen = ref(false)
const scrolled = ref(false)

const userStore = useAuthStore()
const router = useRouter()

const isAuthenticated = computed(() => userStore.isAuthenticated)

const onScroll = () => {
    scrolled.value = window.scrollY > 8
}

onMounted(() => {
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
})

onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)
})

const headerClasses = computed(() => {
    const base = 'bg-background/95 backdrop-blur-sm text-gold p-4 sticky top-0 z-[9999] transition-shadow transition-border duration-200'
    return scrolled.value
        ? `${base} border-b border-gold/10 shadow-sm`
        : `${base} border-b-0 shadow-none`
})

const logout = async () => {
    await userStore.logout()
    router.push({ name: 'LoginRegister', query: { view: 'login' } })
}
</script>
